module.exports = __webpack_public_path__ + "static/media/delete.52baa6d9.svg";